import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { UserService } from '../../_service/user.service';
import { SharedService } from '../../_service/shared.service';
import {PageEvent, MatPaginator} from '@angular/material/paginator';
import {MatDialog} from '@angular/material/dialog';
import {UpdateInsuranceModalComponent} from '../../insurance/update-insurance-modal/update-insurance-modal.component';
import * as XLSX from 'xlsx';
import {formatDate} from '@angular/common';
declare var $: any;
@Component({
  selector: 'app-insurance-list',
  templateUrl: './insurance-list.component.html',
  styleUrls: ['./insurance-list.component.css']
})
export class InsuranceListComponent implements OnInit {
    perpage:number=25;leads:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;treatment='';
    pageSizeOptions = [10,25,50,100];pageIndex:number=0;bds=[];loaded:boolean=false;circles=[];circle='';sc3Url:string='';assigned_to='';
    search:string;lead_source:string;lead_status:string;bd:string;start_date:string='';end_date:string='';treatments=[];start_date1:string='';end_date1:string='';
    submitted:boolean=false;bds_copy=[];treatments_copy=[];showPendingInsuranceCard:string;leadallStatus=[];leadStatus_copy=[];insbds=[];
    insurance_status:string;payment_mode:string;
    loginuserId:any;insuranceUsers=[];insuranceAllAccess:any;updatedLodData=[];history_loading:boolean=true;history_loaded:boolean=false;
    
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    @ViewChild('dateRangeStart1', {static: false}) dateRangeStart1: ElementRef;
    @ViewChild('dateRangeEnd1', {static: false}) dateRangeEnd1: ElementRef;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    
    constructor(private leadapi:LeadsService,private sharedapi:SharedService,private dialog:MatDialog, private userapi:UserService) { }

    ngOnInit(): void 
    {
        this.getbds();this.getcircle();
        this.getTreatment();
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.loginuserId = localStorage.getItem('loginuserId');
        this.insuranceAllAccess = localStorage.getItem('insuranceAllAccess');
        this.sc3Url= localStorage.getItem('s3url');
        this.getleadStatus();
        this.getbdsOfInsurance();
        if(this.myrole == '1' || this.insuranceAllAccess=='1') this.getInsuranceUser();
    }

    ngAfterViewInit() {
         this.loadInsuranceList(0,this.perpage);
    }

    setSearchValue(type){
        if(type=='lead_owner'){
            $("#ownerSearch").val('');
            $("#ownerSearch").focus();
            this.bds= this.bds_copy;
        }else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }else if(type=='lead_status'){
            $("#lead_status_Search").val('');
            $("#lead_status_Search").focus();
            this.leadallStatus= this.leadStatus_copy;
        }
    }

    searchOnSelect(searchtText: string, type){
        if(type == 'lead_owner'){
             this.bds = this.sharedapi.searchData(searchtText, this.bds_copy, "name");
        }else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }

    async getleadStatus()
    {
        await this.leadapi.getLeadStatus().subscribe((data:any) => {
            if(data.status)
            {
                this.leadallStatus = data.data;
                this.leadStatus_copy = this.leadallStatus;
            }else{
                this.leadallStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    loadInsuranceList(pageIndex,perpage)
    {
        this.leads = [];
        this.paginator.pageIndex = pageIndex; 
        let qString = 'insurance_status='+this.insurance_status+'&lead_status='+this.lead_status+'&search='+this.search+'&circle='+this.circle+'&treatment='+this.treatment+'&assigned_to='+this.assigned_to+'&bd='+this.bd+'&date_range='+this.start_date+'-'+this.end_date+'&updated_status_date_range='+this.start_date1+'-'+this.end_date1+'&pendingInsurance='+this.showPendingInsuranceCard;
        this.loading = true;this.loaded = false;
        this.leadapi.getInsuranceList(this.paginator.pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.leads = data.data;
            }else{
                this.leads = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadInsuranceList(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadInsuranceList(event.pageIndex,event.pageSize);
    }

    async getbds()
    {
        await this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
                this.bds_copy= this.bds;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    async getbdsOfInsurance()
    {
        await this.leadapi.getbdsOfInsurance().subscribe((data:any) => {
            if(data.status)
            {
                this.insbds = data.data;
            }else{
                this.insbds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            this.loadInsuranceList(0,this.perpage);
        }
    }

    dateRangeChange1(date1,date2)
    {
        if(date2.value)
        {
            this.start_date1 = date1.value;
            this.end_date1 = date2.value;
            this.loadInsuranceList(0,this.perpage);
        }
    }
    
    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        this.loadInsuranceList(0,this.perpage);
    }

    clearDate2()
    {
        this.dateRangeStart1.nativeElement.value = "";
        this.dateRangeEnd1.nativeElement.value = "";
        this.start_date1 = '';
        this.end_date1 = '';
        this.loadInsuranceList(0,this.perpage);
    }

    openInsuranceDialog(lead_id)
    {
        const dialogRef = this.dialog.open(UpdateInsuranceModalComponent, {
            width: '100%',
            height: '90%',
            data:{lead_id:lead_id}
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }
    
    getRoomCategory(room)
    {
        return this.sharedapi.getRoomCategory(room);
    }
    
    exportInsuranceList()
    {
        if(this.leads.length>0)
        {
            let data = [];
            let titles = ['Lead Name','Lead Location','Lead Status','Circle','Lead Owner','Treatment','Policy Number','Insurance Company','TPA','Sum Insured','Balance Sum Insured','Room Rent','Room Type','Copay','Corporate','Employee ID','Description','Created Date'];

            if(this.myrole=="1")
            {
                titles.push('Lead Mobile');
            }

            if(this.insuranceAllAccess == '1' || this.myrole == '1') titles.push('Assigned To')
            data.push(titles);
            
            for(let key in this.leads)
            {
                if(this.leads[key].copay == 1){
                    this.leads[key].copay = "0";
                }
                let extData = [this.leads[key].lead_name,this.leads[key].city_name,this.leads[key].lead_status_name,this.leads[key].circle_name,this.leads[key].bd_name,this.leads[key].treatment_name,this.leads[key].policy_number,this.leads[key].insurance_company,
                this.leads[key].tpa,this.leads[key].sum_insured,this.leads[key].balance_sum_insured,this.leads[key].room_rent,this.getRoomCategory(this.leads[key].room),this.leads[key].copay,this.leads[key].corporate,this.leads[key].employee_id,this.leads[key].insurance_description,formatDate(this.leads[key].created_at*1000, 'dd MMM, yyyy hh:mm aa', 'en-US')];
                 if(this.insuranceAllAccess == '1' || this.myrole == '1') extData.push(this.leads[key].assign_to)

                if(this.myrole=="1")
                {
                    extData.push(this.leads[key].mobile);
                }

                data.push(extData)
            }
            let ws = XLSX.utils.aoa_to_sheet(data);
           /* generate workbook and add the worksheet */
           const wb: XLSX.WorkBook = XLSX.utils.book_new();
           XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

           /* save to file */
           let utc = new Date().toJSON().slice(0,10).replace(/-/g,'/');
           XLSX.writeFile(wb, 'insurancelist'+utc+'.xlsx');
        }else{
            this.sharedapi.presentToast('No Insurance Data found!');
        }
    }

    getInsuranceUser()
    {
        this.userapi.getUserByRole(5).subscribe((data:any) => {
            if(data.status)
            {
                this.insuranceUsers = data.data;
            }else{
                this.insuranceUsers = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    updateAssignee(userId: number, insuranceId: number)
    {
        this.leadapi.updateAssignee(userId, insuranceId).subscribe((data:any) => {
            if(data.status) {
                this.sharedapi.presentToast(data.msg);
                this.loadInsuranceList(this.pageIndex,this.perpage);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    openleadHistoryPopup(insuranceId)
    {
        this.history_loading = true;this.history_loaded = false;
        this.leadapi.getFullInsuranceLeadHistory(insuranceId).subscribe((data:any) => {
            this.history_loading = false;
            this.history_loaded = true;
            if(data.status)
            {
                this.updatedLodData = data.data;
            }else{
                this.updatedLodData = [];
            }
        }, error => {
                this.sharedapi.checkError(error);
        });
        $('#myHistoryModal').modal();
    }

    closeHistoryPopup()
    {
        $('#myHistoryModal').modal('hide');
    }
    resetFilters() {
        this.search = ''; this.bd =''; this.assigned_to =''; this.circle = ''; this.treatment=''; this.lead_status=''; 
        this.insurance_status ='undefined';
        this.loadInsuranceList(0,25);
      }
}
